
import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome'
import {Button} from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte'
import SearchCarBox from '../../component/element/SearchCarBox'
import WorkDocAttachmentDoc from './WorkDocAttachmentDoc';


class SWTWorkUpload extends Component {

  constructor(...args){
    super(...args)
    this.state = {item:null,workNo:'',showWork:false}
  }


  onSelect(item){
    this.setState({item:item,workNo:item.work_no,showWork:true})
  }

  onCloseClick(){
    this.setState({workNo:'',showWork:false})
  }

  render(){
    let {workNo,showWork,item} = this.state
    let title = (item)?item.Value+' - '+item.car_info:''
    return (
      <div>
        <div style={{display:(!showWork)?'block':'none'}}>
          <SearchCarBox onSelect={this.onSelect.bind(this)}/>        
        </div>
        <div style={{display:(showWork)?'block':'none'}}>
          <Box>
            <Box.Header>
              <Box.Title>
                <FontAwesome className="text-yellow" name="car" /> {title}
              </Box.Title>
              <Box.Tools>
                <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close'/>{' '} ปิด</Button>
              </Box.Tools>
            </Box.Header>
            <Box.Body>
              <WorkDocAttachmentDoc  workNo={workNo} showPrint={false}/>
            </Box.Body>
          </Box>                    
        </div>
      </div>
    )
  }
}


export default SWTWorkUpload;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWorkUpload.js